import * as React from "react";
import { forwardRef, useImperativeHandle } from "react";
import isFunction from "lodash/isFunction";
import FormListContext from "./form-list.context.js";
import useFormList from "./use-form-list.js";
export default forwardRef(function FormList({ name: field, children, defaultValue }, ref) {
    const [fields, operation] = useFormList(field, { defaultValue });
    useImperativeHandle(ref, () => operation, [operation]);
    return (React.createElement(FormListContext.Provider, { value: {
            inFormList: true,
        } }, isFunction(children) && children(fields, operation)));
});
